import { preferInstantViewerMotion } from 'features/knowledgeDocumentViewer/components/viewer/shared/preferInstantViewerMotion'
import type { ReactZoomPanPinchProps } from 'react-zoom-pan-pinch'

export type TransformWrapperMotionProps = Pick<
  ReactZoomPanPinchProps,
  'alignmentAnimation' | 'velocityAnimation'
>

/**
 * Returns alignment and velocity animation props for react-zoom-pan-pinch's
 * TransformWrapper, disabling motion on coarse pointers, prefers-reduced-motion,
 * and Safari composite rendering.
 */
export function transformWrapperMotionProps(): TransformWrapperMotionProps {
  const instant = preferInstantViewerMotion()
  if (instant) {
    return {
      alignmentAnimation: { sizeX: 0, sizeY: 0, animationTime: 0 },
      velocityAnimation: { disabled: true, sensitivity: 1 },
    }
  }
  return {
    alignmentAnimation: { sizeX: 100, sizeY: 100 },
  }
}
